import { supabase } from '../supabase';

export const calculateTaskerEarnings = async (taskId: number): Promise<number> => {
  const { data: task, error } = await supabase
    .from('tasks')
    .select('base_amount, price, original_price, coupon_id')
    .eq('id', taskId)
    .single();

  if (error) throw error;
  if (!task) throw new Error('Task not found');

  if (task.coupon_id && task.original_price) {
    return task.original_price * 0.85; // 85% (15% de comisión)
    /* Anterior cálculo con 20% + IVA:
    return (task.original_price * 0.81) * 0.8; // 80% of the original price */
  } else {
    return task.base_amount * 0.85; // monto base sin fee ni IVA
  }
};
